// src/contexts/BaseSocketContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const BaseSocketContext = createContext();

export const useBaseSocket = () => {
    return useContext(BaseSocketContext);
};

export const BaseSocketProvider = ({ children }) => {
    const { user } = useAuth();
    const [socket, setSocket] = useState(null);
    const [connected, setConnected] = useState(false);
    const SOCKET_URL = window._env_ ? window._env_.SOCKET_URL : process.env.REACT_APP_SOCKET_URL;

    // Setup socket connection when user changes
    useEffect(() => {
        if (!user) return;

        console.log('BaseSocketContext.js', SOCKET_URL);
        
        // Connect to Socket.IO server
        const socketInstance = io(SOCKET_URL || window.location.origin, {
            auth: {
                token: localStorage.getItem('token')
            }
        });

        // Set up event listeners
        socketInstance.on('connect', () => {
            console.log('Socket connected');
            setConnected(true);
        });

        socketInstance.on('disconnect', () => {
            console.log('Socket disconnected');
            setConnected(false);
        });

        // Debug listener - will catch all events for debugging
        socketInstance.onAny((event, ...args) => {
            console.log(`[Socket Debug] Event: ${event}`, args);
        });

        setSocket(socketInstance);

        // Clean up on unmount
        return () => {
            if (socketInstance) {
                socketInstance.disconnect();
            }
        };
    }, [user, SOCKET_URL]);

    const emitEvent = (eventName, data) => {
        if (socket && connected) {
            socket.emit(eventName, data);
        } else {
            console.error('Socket not connected, cannot emit event');
        }
    };

    const value = {
        socket,
        connected,
        emitEvent
    };

    return (
        <BaseSocketContext.Provider value={value}>
            {children}
        </BaseSocketContext.Provider>
    );
};

export default BaseSocketContext;